import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  TextField,
  Typography,
  Modal,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import LayoutAdminHeader from '../components/LayoutAdminHeader';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const GetAllRegistrations = () => {
  const [registrations, setRegistrations] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  // Reset password modal state
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [newPassword, setNewPassword] = useState('');

  useEffect(() => {
    fetchRegistrations();
  }, []);

  const fetchRegistrations = () => {
    axios
      .get(`${BASE_URL}/Registration/GetAllRegistrations`)
      .then((res) => {
        const data = res.data.data || [];
        const sorted = data.sort(
          (a, b) =>
            new Date(b.createdDateTime) - new Date(a.createdDateTime)
        );
        setRegistrations(sorted);
        setFilteredData(sorted);
      })
      .catch((err) => console.error('Error:', err))
      .finally(() => setLoading(false));
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = registrations.filter((row) =>
      (row.firstName + ' ' + row.lastName).toLowerCase().includes(value) ||
      row.emailId?.toLowerCase().includes(value) ||
      row.mobileNumber?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const handleEdit = (id) => navigate(`/UserRegistration/${id}`);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure to delete?')) {
      axios
        .delete(`${BASE_URL}/Registration/DeleteRegistration/${id}`)
        .then(() => {
          alert('Deleted successfully');
          fetchRegistrations();
        })
        .catch((err) => console.error(err));
    }
  };

  const handleOpenReset = (id) => {
    setSelectedUserId(id);
    setNewPassword('');
    setResetModalOpen(true);
  };

  const handleResetPassword = async () => {
    if (!newPassword.trim()) {
      alert('Please enter a new password.');
      return;
    }

    try {
      const token = localStorage.getItem("token");

const res = await axios.put(
  `${BASE_URL}/Registration/ResetPassword/${selectedUserId}`,
  {
    password: newPassword,
  },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      alert('Password reset successful.');
      setResetModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('Password reset failed.');
    }
  };

  const columns = [
    { field: 'lastName', headerName: 'Name', flex: 1 },
    { field: 'emailId', headerName: 'Email', flex: 1 },
    { field: 'mobileNumber', headerName: 'Mobile', flex: 1 },
    { field: 'stateName', headerName: 'State', flex: 1 },
    { field: 'districtName', headerName: 'District', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1.5,
      sortable: false,
      renderCell: (params) => {
        const row = params?.row || {};
        return (
          <>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleEdit(row.id)}
            >
              Edit
            </Button>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => handleDelete(row.id)}
              sx={{ ml: 1 }}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => handleOpenReset(row.id)}
              sx={{ ml: 1 }}
            >
              Reset Password
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <>
      <LayoutAdminHeader />
      <Box p={2}>
        <Typography variant="h5" gutterBottom>
          User Registrations
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/UserRegistration')}
          sx={{ mb: 2 }}
        >
          + Add New
        </Button>

        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={search}
          onChange={handleSearch}
          sx={{ mb: 2 }}
        />

        <DataGrid
          autoHeight
          rows={filteredData.map((row, index) => ({
            ...row,
            id: row.id || index,
          }))}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 20]}
          loading={loading}
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              fontWeight: 'bold',
              fontSize: '16px',
            },
            '& .MuiDataGrid-cell': {
              fontSize: '14px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#fafafa',
            },
          }}
        />
      </Box>

      <Modal open={resetModalOpen} onClose={() => setResetModalOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Reset Password
          </Typography>
          <TextField
            label="New Password"
            variant="outlined"
            fullWidth
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleResetPassword}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default GetAllRegistrations;
